import { render, staticRenderFns } from "./PresetLayout.vue?vue&type=template&id=c8466e52&"
import script from "./PresetLayout.vue?vue&type=script&lang=ts&"
export * from "./PresetLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports